export const BULK_TEST_ITEM_CONFIG = [
    {
        key: 'height_weight', label: '身高体重', items: [
            { key: 'height', label: '身高', unit: 'cm', type: 'number' },
            { key: 'weight', label: '体重', unit: 'kg', type: 'number' }
        ], category: '身体形态', grades: ['小学', '初中', '高中']
    },
    { key: 'vital_capacity', label: '肺活量', unit: 'ml', type: 'digit', category: '身体机能', grades: ['小学', '初中', '高中'] },
    { key: 'run_50m', label: '50米跑', unit: '秒', type: 'number', category: '身体素质', grades: ['小学', '初中', '高中'] },
    { key: 'sit_and_reach', label: '坐位体前屈', unit: 'cm', type: 'number', category: '身体素质', grades: ['小学', '初中', '高中'] },
    { key: 'skip_rope', label: '1分钟跳绳', unit: '次', type: 'digit', category: '身体素质', grades: ['小学'] },
    { key: 'sit_up', label: '1分钟仰卧起坐', unit: '次', type: 'digit', category: '身体素质', grades: ['小学', '初中', '高中'] },
    { key: 'standing_long_jump', label: '立定跳远', unit: 'cm', type: 'digit', category: '身体素质', grades: ['小学', '初中', '高中'] },
    { key: 'pull_up', label: '引体向上', unit: '次', type: 'digit', category: '身体素质', grades: ['初中', '高中'] },
    { key: 'run_50m_8x', label: '50x8往返跑', unit: '分·秒', type: 'number', category: '身体素质', grades: ['小学'] },
    { key: 'run_800m', label: '800米跑', unit: '分·秒', type: 'number', category: '身体素质', grades: ['初中', '高中'] },
    { key: 'run_1000m', label: '1000米跑', unit: '分·秒', type: 'number', category: '身体素质', grades: ['初中', '高中'] },
];

export const SINGLE_TEST_ITEM_CONFIG = [
    { key: 'height', label: '身高', unit: 'cm', type: 'number', category: '身体形态', grades: ['小学', '初中', '高中'] },
    { key: 'weight', label: '体重', unit: 'kg', type: 'number', category: '身体形态', grades: ['小学', '初中', '高中'] },
    { key: 'vital_capacity', label: '肺活量', unit: 'ml', type: 'digit', category: '身体机能', grades: ['小学', '初中', '高中'] },
    { key: 'run_50m', label: '50米跑', unit: '秒', type: 'number', category: '身体素质', grades: ['小学', '初中', '高中'] },
    { key: 'sit_and_reach', label: '坐位体前屈', unit: 'cm', type: 'number', category: '身体素质', grades: ['小学', '初中', '高中'] },
    { key: 'skip_rope', label: '1分钟跳绳', unit: '次', type: 'digit', category: '身体素质', grades: ['小学'] },
    {
        key: 'sit_up', label: '1分钟仰卧起坐', unit: '次', type: 'digit', category: '身体素质', grades: ['小学', '初中', '高中'],
        gradeFilter: (g) => !['一', '二'].some(k => g.includes(k)) || !['一', '二', '三', '四', '五', '六'].some(k => g.includes(k)),
        genderRules: (g, gender) => ['一', '二', '三', '四', '五', '六'].some(k => g.includes(k)) || gender === 'female'
    },
    { key: 'standing_long_jump', label: '立定跳远', unit: 'cm', type: 'digit', category: '身体素质', grades: ['初中', '高中'] },
    { key: 'pull_up', label: '引体向上', unit: '次', type: 'digit', category: '身体素质', grades: ['初中', '高中'], gender: ['male'] },
    {
        key: 'run_50m_8x', label: '50x8往返跑', unit: '分·秒', type: 'number', category: '身体素质', grades: ['小学'],
        gradeFilter: (g) => ['五', '六'].some(k => g.includes(k))
    },
    { key: 'run_800m', label: '800米跑', unit: '分·秒', type: 'number', category: '身体素质', grades: ['初中', '高中'], gender: ['female'] },
    { key: 'run_1000m', label: '1000米跑', unit: '分·秒', type: 'number', category: '身体素质', grades: ['初中', '高中'], gender: ['male'] },
];

export const CALCULATOR_ITEMS = [
    { key: 'height', label: '身高', unit: 'cm', type: 'number', placeholder: '支持1位小数, 如 145.5' },
    { key: 'weight', label: '体重', unit: 'kg', type: 'number', placeholder: '支持1位小数, 如 43.2' },
    { key: 'vital_capacity', label: '肺活量', unit: 'ml', type: 'digit', placeholder: '请输入肺活量' },
    { key: 'run_50m', label: '50米跑', unit: 's', type: 'number', placeholder: '支持1位小数, 如 8.5' },
    { key: 'sit_and_reach', label: '坐位体前屈', unit: 'cm', type: 'number', placeholder: '支持1位小数, 如 12.5' },
    { key: 'skip_rope', label: '1分钟跳绳', unit: '次', type: 'digit', placeholder: '请输入1分钟跳绳成绩' },
    { key: 'sit_up', label: '1分钟仰卧起坐', unit: '次', type: 'digit', placeholder: '请输入1分钟仰卧起坐成绩' },
    { key: 'run_50m_8x', label: '50米×8往返跑', unit: '分.秒', type: 'number', placeholder: "直接输入, 如1.18表示1分18秒" },
];

export const CALCULATOR_ITEM_LABELS = {
    height_weight: '身高体重/BMI',
    bmi: '体重指数(BMI)',
    vital_capacity: '肺活量',
    run_50m: '50米跑',
    sit_and_reach: '坐位体前屈',
    skip_rope: '1分钟跳绳',
    sit_up: '1分钟仰卧起坐',
    run_50m_8x: '50米×8往返跑',
};

export const DETAIL_ITEM_NAMES = {
    height: '身高 (cm)',
    weight: '体重 (kg)',
    bmi: 'BMI',
    vital_capacity: '肺活量 (ml)',
    run_50m: '50米跑 (s)',
    sit_and_reach: '坐位体前屈 (cm)',
    skip_rope: '1分钟跳绳 (个)',
    standing_long_jump: '立定跳远 (cm)',
    sit_up: '1分钟仰卧起坐 (个)',
    run_50m_8x: '50米×8往返跑 (分·秒)',
    run_800m: '800米跑 (分·秒)',
    run_1000m: '1000米跑 (分·秒)',
    pull_up: '引体向上 (个)'
};
